"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetViewScope = exports.PresetViewSupportedView = void 0;
var PresetViewSupportedView;
(function (PresetViewSupportedView) {
    PresetViewSupportedView[PresetViewSupportedView["Dispatch"] = 0] = "Dispatch";
    PresetViewSupportedView[PresetViewSupportedView["Planning"] = 1] = "Planning";
    PresetViewSupportedView[PresetViewSupportedView["OrderAlerts"] = 2] = "OrderAlerts";
    PresetViewSupportedView[PresetViewSupportedView["DriverAlerts"] = 3] = "DriverAlerts";
    PresetViewSupportedView[PresetViewSupportedView["OptimisationAlerts"] = 4] = "OptimisationAlerts";
})(PresetViewSupportedView || (exports.PresetViewSupportedView = PresetViewSupportedView = {}));
var PresetViewScope;
(function (PresetViewScope) {
    PresetViewScope["Merchant"] = "merchant";
    PresetViewScope["User"] = "user";
})(PresetViewScope || (exports.PresetViewScope = PresetViewScope = {}));
//# sourceMappingURL=preset_view.js.map